'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logoMin = require('../../assets/img/logo-min.svg');

var _logoMin2 = _interopRequireDefault(_logoMin);

require('../../assets/css/components/structure/FooterUEPB.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FooterUEPB = function (_Component) {
    _inherits(FooterUEPB, _Component);

    function FooterUEPB() {
        _classCallCheck(this, FooterUEPB);

        return _possibleConstructorReturn(this, (FooterUEPB.__proto__ || Object.getPrototypeOf(FooterUEPB)).apply(this, arguments));
    }

    _createClass(FooterUEPB, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'footer',
                { title: 'Rodap\xE9 UEPB', id: 'rodape-uepb' },
                _react2.default.createElement(
                    'div',
                    { id: 'rodape-pagina-inicial' },
                    _react2.default.createElement(
                        'div',
                        { id: 'logo-uepb' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'section',
                                null,
                                _react2.default.createElement('img', { src: _logoMin2.default, alt: 'logo UEPB' })
                            ),
                            _react2.default.createElement(
                                'section',
                                null,
                                'UEPB'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Desenvolvido por: CTIC ',
                            _react2.default.createElement('br', null),
                            'Coordenadoria de Tecnologia da Informa\xE7\xE3o e Comunica\xE7\xE3o ',
                            _react2.default.createElement('br', null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: 'enredeco-uepb' },
                        '\xA9 2018 UEPB - Universidade Estadual da Para\xEDba - CNPJ: 12.671.814/0001-37 ',
                        _react2.default.createElement('br', null),
                        'Rua Bara\xFAnas, 351 - Bairro Universit\xE1rio - Campina Grande-PB, CEP 58429-500, Fone/Fax: 83 3315.3300'
                    )
                )
            );
        }
    }]);

    return FooterUEPB;
}(_react.Component);

exports.default = FooterUEPB;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/structure/FooterUEPB.js
// module id = 594
// module chunks = 0